export default class FormatDateToOrdinal {
    static dateFormate(dateString) {
        const htmlLang = (document.documentElement.getAttribute('lang') || '').trim();
        const locale = htmlLang || 'en-US';
        const date = new Date(dateString);
        const day = date.getDate();
        const month = new Intl.DateTimeFormat(locale, { month: 'long' }).format(date);
        const year = date.getFullYear();

        const formattedDate = `${day} ${month} ${year}`;

        return formattedDate;
    }
}
